import { render, staticRenderFns } from "./SistemaPage.vue?vue&type=template&id=05355c34"
import script from "./SistemaPage.js?vue&type=script&lang=js&external"
export * from "./SistemaPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports